import React from 'react';

import useCioBrowseAndGqlProducts from '../../hooks/useCioBrowseAndGqlProducts';
import { groupSizeFacets } from '../../utils/filters';

import DesktopGridFilterRenderer from './DesktopGridFilterRenderer';
import DesktopGridSelectedFilters from './DesktopGridSelectedFilters';

const DesktopGridFilters = () => {
  const { cioFacets } = useCioBrowseAndGqlProducts();

  const groupedFacets = groupSizeFacets(cioFacets);

  return (
    <div>
      <DesktopGridSelectedFilters />
      <ul className="flex flex-col">
        {groupedFacets?.map((facet) => (
          <li key={facet?.name} className="[&:not(:last-child)]:border-b-2">
            <DesktopGridFilterRenderer facet={facet} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DesktopGridFilters;
